
import PageHeader from "app/shared/PageHeader";
import "./Dashboard.scss";
import CustomReconTabs from "../Reconcilation/components/CustomReconTabs";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import {
  onboardingMessageShown,
  tabViewStates,
  userInfo,
  workspaceReports,
} from "app/config/States/users";
import Loader from "app/shared/Loader";
import { Empty, Modal, Tabs } from "antd";
import { useNavigate, useRouteError } from "react-router-dom";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { getSubdomain } from "app/utils/generic.helper";
import {
  DASHBOARD_LINK_ZOHO_CRITERIA_FILTER,
  dashboardTabConfig,
  dashboardURLConfig,
} from "global.constants";
import { Mixpanel } from "app/config/Mixpanel";
import Typography from "app/shared/Typography";
import { MarginTwoTone } from "@mui/icons-material";
import { colorPicker } from "app/utils/color.helper";
import { FinkAnalytics } from "app/utils/GoogleAnalytics";
import { PostHogProvider } from 'posthog-js/react'
import posthog from 'posthog-js';
import ZAViewSelector from "app/shared/ZAViewSelector";
export default function Dashboard(props: any) {
  const [activeKey, setActiveKey] = useState("1");
  const [userDetails, _] = useRecoilState<any>(userInfo);
  const [tabViews, setTabView] = useRecoilState<any>(tabViewStates);
  const [reports, setWorkspaceReports] = useRecoilState<any>(workspaceReports);
  const [onboardingMessage, setShowOnboardingMessage] = useRecoilState<any>(
    onboardingMessageShown
  );
  const [isLoading, setLoading] = useState(false);
  const [dashboardURL, setDashboardURL] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  Mixpanel.track("User Landed On Dashboard", { Screen: "Dashboard" });
  const domain: any = getSubdomain();

  posthog.init('phc_sqVedcbiO1p6MDNKAwkqNokw9vWJd73mwr8c9CEUn1P',
    {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'identified_only' ,
        capture_pageview: true,
        debug: true,
    }
  )

  useEffect(() => {
    setLoading(true);
  
    const hostname = window.location.hostname;
    const isLocalhost =
      hostname === "localhost" || hostname === "127.0.0.1" || hostname === "";
    const subdomain = hostname.split(".")[0];
  
    const email = userDetails?.email?.toLowerCase();
    const blockedDomains = ["kgrp.in", "finkraft.ai"];
    const userDomain = email?.split("@")[1];
  
    const isBlocked = blockedDomains.includes(userDomain);
  
    if (!isLocalhost && userDetails?.id && email) {
      if (!isBlocked) {
        // ✅ Allow PostHog tracking
        posthog.identify(userDetails.id, {
          name: userDetails.name,
          email: userDetails.email,
          workspace_name: userDetails.currentWorkspace?.name,
          subdomain,
        });
  
        posthog.capture("user_details_captured", {
          name: userDetails.name,
          email: userDetails.email,
          workspace_name: userDetails.currentWorkspace?.name,
          subdomain,
          access_date: new Date().toISOString().split("T")[0],
        });
      } else {
        // 🚫 Block PostHog tracking
        console.log("PostHog disabled for:", email);
        posthog.reset(); // clears cookies & identity
      }
    }
  
    // Google Analytics tracking stays (if you still want it)
    if (userDetails?.id && typeof window.gtag === "function") {
      window.gtag("config", "G-YGHTMQESH6", {
        user_id: userDetails.id,
      });
    }
  
    // ... keep your FinkAnalytics call here if needed
  
    setTimeout(() => {
      setLoading(false);
      if (!onboardingMessage && subdomain === "app") setShowModal(true);
    }, 2000);
  }, [userDetails]);
  
  console.log("user details for dashboard", userDetails);

  const getFormattedURL = (url: any) => {
    let link =
      url ||
      "https://analytics.zoho.in/open-view/103074000038657277/3b131ffff66b66a9688aaeeddc4fa06d";
    if (userDetails.currentWorkspace?.meta?.full_access) {
      return link;
    } else {
      const workspaceName = userDetails.currentWorkspace?.name;
      // Encode only the workspace name
      const encodedWorkspaceName = encodeURIComponent(workspaceName);
      // Build the filter key
      const filterKey =
        DASHBOARD_LINK_ZOHO_CRITERIA_FILTER[domain]?.[activeKey] || "workspace";
      // Combine pre-encoded key/value structure with encoded workspace name
      const actualUrl = `${link}?ZOHO_CRITERIA=%22${filterKey}%22%3D%27${encodedWorkspaceName}%27`;
      return actualUrl;
    }
  };

  const getDashboardOptionVisible = (options: any) => {
    const menus = Array.isArray(options)
      ? options.filter(
          (menu: any) =>
            !menu.adminOnly || userDetails.currentWorkspace?.meta?.full_access
        )
      : [];

    if (domain === "app") {
      menus.push({ key: "3", label: "Dashboard - Credential" });
    }

    return menus;
  };

  posthog.capture('my event', { property: 'value' })

  posthog.capture('user_clicked_invoice_download', {
    workspace: 'MMT',
    location: 'flights_page',
  });

  let initialMenus: any =
    getDashboardOptionVisible(dashboardTabConfig[domain]) || [];
  const handleRedirectOnboarding = () => {
    setShowOnboardingMessage(true);
    setActiveKey("3");
    setShowModal(false);
  };
  return isLoading ? (
    <Loader />
  ) : (
    <div className="Dashboard">
      <div className="ScreenContainer">
        <PageHeader
          leftActions={
            <div style={{ display: "flex", alignItems: "center" }}>
            {/* <ZAViewSelector
              activeKey={activeKey === "Credential" ? "" : activeKey}
              items={reports?.dashboards || []}
              onViewChange={(data: any, fullObj: any) => setActiveKey(data)}
            /> */}
            <div style={{ marginLeft: 12 }}>
             <Tabs
              items={initialMenus}
              tabBarStyle={{
                borderBottom: "none", // Remove the underline border
                margin: 0,
              }}
              activeKey={activeKey}
              onChange={(tabItem: string) => setActiveKey(tabItem)}
            />
            </div>
          </div>
            // <Tabs
            //   items={initialMenus}
            //   tabBarStyle={{
            //     borderBottom: "none", // Remove the underline border
            //     margin: 0,
            //   }}
            //   activeKey={activeKey}
            //   onChange={(tabItem: string) => setActiveKey(tabItem)}
            // />
          }
          // leftActions={
          //   <CustomReconTabs
          //     activeKey={activeKey}
          //     title="Report"
          //     onTabChange={(tabKey: any) => setActiveKey(tabKey)}
          //     onTabModify={(tabs: any) =>
          //       setTabView({ ...tabViews, dashboard: tabs })
          //     }
          //     hideAddTab
          //     hideRemove
          //     defaultTabs={getTabView()}
          //     width={200}
          //   />
          // }
        />

        <div className="TableContainer">
          <iframe
            height="100%"
            style={{ width: "100%" }}
            scrolling="no"
            title="Iframe"
            id="dashboardFrame"
            src={
              getFormattedURL(dashboardURLConfig[domain]?.[activeKey]) ||
              "https://analytics.zoho.in/open-view/103074000038657277/3b131ffff66b66a9688aaeeddc4fa06d"
            }
          ></iframe>
        </div>
      </div>

      <Modal
        title={false}
        footer={false}
        open={showModal}
        closable={false}
        width={500}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">
            {" "}
            <ExclamationCircleFilled
              style={{ marginRight: 4, color: "#e67e22" }}
            />
            Require immediate action
          </Typography>
          <Typography
            variant="xs"
            style={{ color: "#7e7979", textAlign: "center", marginTop: 6 }}
          >
            Onboarding steps pending , you will be redirected to on boarding
            dashboard review the data sets which are missing then go to
            integration tab and complete the pending items.{" "}
            <strong
              style={{ cursor: "pointer", color: colorPicker("primary.700") }}
              onClick={handleRedirectOnboarding}
            >
              Complete Now
            </strong>
          </Typography>
        </div>
      </Modal>
    </div>
  );
}
